import script from "./BlockLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockLinks.vue?vue&type=script&setup=true&lang=js"

import "./BlockLinks.vue?vue&type=style&index=0&id=2be3c86b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be3c86b"]])

export default __exports__